<template>
  <b-modal id="mdlEditRigaDocumento" @shown="onModalShown" ref="mdlEditRigaDocumento" :title="getTitoloModal()"
    modal-class="sa-modal-static-scroll" size="xl" @show="onShowRigaDocumento" @hide="onHideRigaDocumento"
    style="height: 100%" ok-hide>
    <b-alert :show="showAlertArticoloPresente" variant="warning" class="text-center shadow-sm rounded-3"
      style="width: 100%">
      <b-row class="align-items-center">
        <b-col cols="12" class="mb-3">
          <h5 class="mb-0">Codice Articolo e Descrizione gia presenti nel documento, aumentare quantita ?</h5>
          <small class="mb-0">Vuoi davvero procedere con questa azione?</small>
        </b-col>
        <b-col cols="12" class="text-end">
          <b-button variant="success" class="px-4" @click="onClickSiArticoloQuantita">Sì</b-button>
          <b-button variant="danger" class="px-4" @click="onClickNoArticoloQuantita">No</b-button>
        </b-col>
      </b-row>
    </b-alert>
    <div class="sa-flexbox">
      <div class="sa-flexbox-header">
        <form ref="form">
          <div class="sa-form-section sa-search-box">
            <b-row>
              <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">📦 {{ this.$i18n.t("billing.lblProductCode") }}</label>
                <div class="sa-search-search-wrapper">
                  <input class="sa-search-box-input" v-model="rigaDocumento.codiceArticolo"
                    placeholder="Codice Articolo" />
                </div>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-search-box-label">📦 {{ this.$i18n.t("billing.lblDescription") }}</label>
                <div class="sa-search-search-wrapper">
                  <input class="sa-search-box-input" v-model="rigaDocumento.descrizione" placeholder="Descrizione" />
                </div>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">📏 Unità Misura</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="rigaDocumento.umCodice"
                  class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :options="getUnitaMisuraArticoli" :value="null"
                  text-field="descrizioneMultiplo" @change="onChangeUnitaMisura" value-field="codiceMoltiplicatore"
                  required :state="rigaDocumento.idUnitaMisuraState">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">🛒 {{ this.$i18n.t("billing.lblTipoSpesa") }}</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="rigaDocumento.codiceTipoSpesa"
                  class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :options="contabilitaTipoSpesaOptions" :value="null"
                  text-field="descrizione" value-field="codice" required :state="rigaDocumento.idTipoSpesaState">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>

              <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">🧾 {{ this.$i18n.t("billing.lblIva") }}</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="rigaDocumento.ivaCodice"
                  @change="onChangeIva" class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :options="contabilitaIvaOptions"
                  :value="null" text-field="descrizioneIva" value-field="codiceIva" required
                  :state="rigaDocumento.idIvaState">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">📊 {{ this.$i18n.t("billing.lblQuantity") }}</label>
                <input type="number" class="sa-search-box-input" v-model="rigaDocumento.quantita"
                  @input="onAggiornaQuantitaRiga" placeholder="Quantità" :state="rigaDocumento.quantitaState" />
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">💰 Prez.Uni.</label>
                <input step="0.01" min="0.00" type="number" class="sa-search-box-input"
                  v-model="rigaDocumento.prezzoUnitario" placeholder="Quantità"
                  :state="rigaDocumento.prezzoUnitarioState" />
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">🏷️ {{ this.$i18n.t("billing.lblDiscountPercentage") }}</label>
                <input step="10" max="100" min="0" type="number" class="sa-search-box-input"
                  v-model="rigaDocumento.sconto" placeholder="Quantità" :state="rigaDocumento.scontoState" />
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">⚙️ Gestione</label>
                <div style="width: 100% !important;" v-if="isCaricoMagazzino">
                  <small v-if="!gestione">NON E' PREVISTA GESTIONE DI LOTTI O
                    MATRICOLE</small>
                  <div v-else v-html="descrizioneGestione"></div>
                </div>

              </b-col>
            </b-row>
          </div>
        </form>
      </div>
      <div class="sa-flexbox-body">
        <div class="sa-flex-box-main" style="background-color: red">
          <div class="sa-flex-box-main-header">
            <div class="sa-flex-box-main-header d-flex align-items-center justify-content-between">
              <div class="d-flex">
                <form ref="form">
                  <div class="sa-search-search-wrapper" style="margin-left: 12px;">
                    <b-form-checkbox v-model="tipoRicerca" @change="valoreFiltro = null" switch>
                    </b-form-checkbox>
                    <input id="test" class="sa-search-box-input" v-model="valoreFiltro"
                      :placeholder="`${tipoRicerca ? 'Ricerca Articolo Nome' : 'Ricerca Articolo Codice'}`" />
                    <button class="sa-ft-floating-btn primary" @click="onRicercaArticolo" title="Cerca">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </form>
              </div>
              <div class="d-flex" v-if="!isCaricoMagazzino">
                <form ref="form">
                  <div class="sa-search-search-wrapper" style="width: 250px; margin-left: 10px;"> <input
                      class="sa-search-box-input w-100" v-model="customFilter.lottoMatricola"
                      placeholder="Codice Lotto Matricola" />
                    <button @click="onRicercaArticolo" class="sa-ft-floating-btn primary" title="Cerca">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </form>
              </div>

              <div class="ml-auto mt-4">
                <b-button size="sm" class="mr-3" variant="outline-purple outline-primary-noborder"
                  @click="onClickGestioneLottoMatricola" v-if="gestione && isCaricoMagazzino">
                  ⚙️
                  Gestione
                </b-button>
                <b-button size="sm" variant="outline-success outline-primary-noborder"
                  @click="onClickAggiungiArticoloNonPresente">
                  <font-awesome-icon icon="plus"></font-awesome-icon>
                  Aggiungi Articolo
                </b-button>

              </div>

            </div>
          </div>
          <div class="sa-flex-box-main-body">
            <div class="sa-flex-box-main-content">
              <MagazzinoArticoliGiacenzaWrapperComponent ref="cmpMagazzinoArticoliWrapper"
                @onRowSelectedArticoliItems="onRowSelectedArticoliItems"
                @updateRowNumberGiacenza="onUpdateRowNumberGiacenza" :isEdit="isModificaRigaDocumento" />
            </div>
          </div>
          <div class="sa-flex-box-main-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
              <b-col lg="3">
                <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rowsGiacenza }}</p>
              </b-col>
              <b-col lg="9">
                <b-pagination v-model="customFilter.page" :total-rows="rowsGiacenza" :per-page="customFilter.forPage"
                  align="right" size="sm"></b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
        <contabilita-documento-riga-aggiungi-articolo-box-component @afterSavedArticolo="onAfterSavedArticolo"
          ref="cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent" />
        <MagazzinoArticoliGestioneLottiMatricoleList @descrizioneGestione="onDescrizioneGestioneUpdate"
          ref="cmpMagazzinoArticoliGestioneLottiMatricoleList" />
      </div>
      <div class="sa-flexbox-footer"></div>
    </div>
    <template #modal-footer>
      <div class="sa-padding-right text-right col" v-if="!isBoxAggiungiArticoloOpen && !isBoxGestioneMatricoleLotti">
        <b-button type="button" variant="secondary" @click="hide()">Chiudi</b-button>
        <b-button type="button" variant="success" @click="onOkRigaDocumento"><span
            v-if="isModificaRigaDocumento">Modifica Riga</span>
          <span v-else>Aggiungi Riga</span></b-button>
      </div>
      <div class="sa-padding-right text-right col" v-if="isBoxAggiungiArticoloOpen">
        <b-button type="button" variant="danger" @click="onClickChiudiBoxArticoloNonPresente">Annulla</b-button>
        <b-button type="button" variant="info" @click="onSalvaNuovoArticoloChiudi">Salva e chiudi</b-button>
      </div>
      <div class="sa-padding-right text-right col" v-if="!isBoxAggiungiArticoloOpen && isBoxGestioneMatricoleLotti">
        <b-button type="button" variant="danger" @click="onClickGestioneLottoMatricolaAnnulla">Annulla</b-button>
        <b-button type="button" variant="purple" @click="onConfermaLottiMatricola">Conferma </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import MagazzinoArticoliGiacenzaWrapperComponent from "../../magazzino/components/MagazzinoArticoliGiacenzaWrapperComponent.vue"
//import MagazzinoArticoliGiacenzeListComponent from "../../magazzino/components/MagazzinoArticoliGiacenzeListComponent.vue";
import ContabilitaDocumentoRigaAggiungiArticoloBoxComponent from "./ContabilitaDocumentoRigaAggiungiArticoloBoxComponent.vue";
import MagazzinoArticoliGestioneLottiMatricoleList from "../../magazzino/components/MagazzinoArticoliGestioneLottiMatricoleListModal.vue"
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
// import DatePicker from "vue2-datepicker";

import UtilityMixin from "../../utility/UtilityMixin";
import toast from "../../../template/layout/utility/sa-toast";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [ContabilitaMixin, MagazzinoMixins, UtilityMixin],
  components: {
    //MagazzinoArticoliGiacenzeListComponent,
    ContabilitaDocumentoRigaAggiungiArticoloBoxComponent,
    MagazzinoArticoliGiacenzaWrapperComponent,
    MagazzinoArticoliGestioneLottiMatricoleList
  },
  props: {
    documento: {
      type: Object,
      default: () => { return {} }
    },
    righeDocumento: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      descrizioneGestione: "",
      isBoxAggiungiArticoloOpen: false,
      isBoxGestioneMatricoleLotti: false,
      showAlertArticoloPresente: false,
      gestione: false,
      valoreFiltro: null,
      presidio: {},
      tipoRicerca: true,
      rowsGiacenza: 0,
      customFilter: {
        page: 1,
        forPage: 50,
        lottoMatricola: null
      },
      jsonData: {},
      isGestioneLottoMatricole: false,
      isModificaRigaDocumento: false,
      arraySelezionati: {
        articolo: null,
      },
      rigaDocumentoSelezionata: null,
      rigaDocumento: {
        id: "-1",
        idArticolo: null,
        codiceArticolo: null,
        descrizione: null,
        umCodice: null,
        umDescrizione: null,
        umMultiplo: 0,
        quantita: 1,
        prezzoUnitario: 0,
        sconto: 0,
        ivaCodice: null,
        ivaDescrizione: null,
        ivaAliquota: 0,
        codiceTipoSpesa: null,
        descrizioneImballo: null,
        colli: 0,
        totaleRiga: 0,
        lottiScadenze: [],
        documentoRiferimentoDescrizione: null,
        documentoRiferimentoId: null,
        documentoRiferimentoRigaId: null,
        documentoRiferimentoRigaQuantita: null,
      },

    };
  },
  watch: {
    'customFilter.page': function () {
      this.ricercaArticolo()
    },
    rigaDocumento: {
      handler(value) {
        if (this.$refs.cmpMagazzinoArticoliWrapper) {
          this.$refs.cmpMagazzinoArticoliWrapper.setRigaDocumento(value);
        }
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    isCaricoMagazzino() {
      return this.jsonData.causaleDocumentoOperazioneMagazzino > 0;
    },
    getUnitaMisuraArticoli() {
      let returnValue = [];
      if (this.arraySelezionati.articolo) {
        let idUm = this.arraySelezionati.articolo[0].umId
        let idUmBase = this.arraySelezionati.articolo[0].umBaseId;
        returnValue = this.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.id === idUm || e.id === idUmBase);
      }

      return returnValue;
    },


  },
  mounted() {
    this.loadDefaultData();
  },
  methods: {

    loadDefaultData() {
      this.mangazzinoArticoliUnitaMisuraLoadData();
      this.contabilitaTipoSpesaLoadData();
      this.contabilitaTabellaIvaLoadData();
      this.getPresidio();
    },
    show() {
      this.$refs.mdlEditRigaDocumento.show();
    },
    hide() {
      this.$refs.mdlEditRigaDocumento.hide();
      this.onResetRigaDocumento();
    },
    getTitoloModal() {
      let returnValue = this.isBoxAggiungiArticoloOpen ? "Crea Nuovo Articolo" : "Crea Riga Documento";
      returnValue = this.isBoxGestioneMatricoleLotti ? "Crea/Modifica Lotti Matricole" : returnValue;
      return returnValue;
    },
    onModalShown() {

      console.log("onmodalshown");

      this.$refs.cmpMagazzinoArticoliWrapper.init(this.documento, this.customFilter, this.rigaDocumento)


      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.init(this.rigaDocumento);

    },
    onShowRigaDocumento() {
      console.log("onShowRigaDocumento");

      this.showAlertArticoloPresente = false;
      this.gestione = false;
    },
    onClickSiArticoloQuantita() {
      let me = this;
      me.showAlertArticoloPresente = false;
      this.$emit("addQuantitaRigaDocumentoPresente", me.rigaDocumento);
      this.hide();
    },

    onDescrizioneGestioneUpdate(item) {
      this.descrizioneGestione = item;
    },

    onClickAddRiga(jsonData) {
      this.jsonData = jsonData;
      this.isModificaRigaDocumento = false;
      this.onResetRigaDocumento();
      this.show();
    },
    onClickGestioneLottoMatricola() {
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.init(this.rigaDocumento);
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.showBox();
      this.isBoxGestioneMatricoleLotti = true;
    },
    onClickGestioneLottoMatricolaAnnulla() {
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.hideBox();
      this.isBoxGestioneMatricoleLotti = false;
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.initListLottoMatricole();
    },
    onConfermaLottiMatricola() {

      let lottiMatricole = this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.getLottiMatricole();
      this.rigaDocumento.lottiScadenze = lottiMatricole;

      let validation = this.validazioneLottiMatricole();
      if (!validation.esito) {
        this.generaBtoast(validation);
        return;
      }
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.hideBox();
      this.isBoxGestioneMatricoleLotti = false;
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.init(this.rigaDocumento);

    },

    onModificaRigaDocumento(row) {
      this.rigaDocumentoSelezionata = row;
      this.rigaDocumento = JSON.parse(JSON.stringify(row.item));
      //this.rigaDocumento.sconto = this.rigaDocumento.sconto * 100;

      this.isModificaRigaDocumento = true;
      this.show();

    },
    onClickNoArticoloQuantita() {
      this.hide();
      this.onResetRigaDocumento();
      if (this.$refs.cmpMagazzinoArticoliGiacenzeListComponent) {
        this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.resetLottoMatricolaRiga();
      }
    },
    onRicercaArticolo() {
      this.ricercaArticolo();
    },
    ricercaArticolo() {
      this.customFilter.nomeArticolo = null;
      this.customFilter.codiceArticolo = null;
      this.customFilter[this.tipoRicerca ? "nomeArticolo" : "codiceArticolo"] = this.valoreFiltro;
      this.customFilter.tipoRicerca = this.tipoRicerca;
      this.$refs.cmpMagazzinoArticoliWrapper.init(this.documento, this.customFilter, this.rigaDocumento);
    },
    onAggiornaQuantitaRiga() {
      this.$refs.cmpMagazzinoArticoliGestioneLottiMatricoleList.init(this.rigaDocumento);
    },
    onChangeUnitaMisura(codiceMoltiplicatore) {
      let um = this.getUnitaMisuraArticoli.filter((e) => e.codiceMoltiplicatore == codiceMoltiplicatore);
      this.setDatiUmRigaDocumento({ umId: um[0].id });
    },
    onChangeIva(codiceIva) {
      this.setDatiIvaRigaDocumento({ codiceIva: codiceIva });
    },
    onAfterSavedArticolo() { },
    onOkRigaDocumento(event) {
      event.preventDefault();
      let validation = this.validazione();
      if (!validation.esito) {
        this.generaBtoast(validation);
        return;
      }
      if (this.arraySelezionati.articolo[0].lottoMatricola) {
        this.setLottoMatricolaSelezionato(this.arraySelezionati.articolo[0].lottoMatricola)
      } else {
        if (this.isModificaRigaDocumento) {
          this.emitModifica();
        } else {
          this.emitAggiungiRiga();
        }
        this.hide();
      }
    },
    emitModifica() {
      this.$emit("modificaRigaDocumento", this.rigaDocumentoSelezionata.index, this.rigaDocumento);
    },
    emitAggiungiRiga() {
      this.$emit("addRigaDocumento", this.rigaDocumento);
    },
    setLottoMatricolaSelezionato(lottoMatricola) {
      this.contabilitaLottoMatricolaByLottoMatricola(lottoMatricola, this.callBackLottoMatricola);
    },
    callBackLottoMatricola(response) {
      let lottoMatricola = response.data.data;
      lottoMatricola.quantita = this.rigaDocumento.quantita
      this.rigaDocumento.lottiScadenze = [lottoMatricola];
      if (this.isModificaRigaDocumento) {
        this.emitModifica();
      } else {
        this.emitAggiungiRiga();
      }
      this.hide();
    },
    onClickAggiungiArticoloNonPresente() {
      this.$refs.cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent.showBox();
      this.isBoxAggiungiArticoloOpen = true;
    },
    onClickChiudiBoxArticoloNonPresente() {
      this.$refs.cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent.hideBox();
      this.isBoxAggiungiArticoloOpen = false;
    },
    onSalvaNuovoArticoloChiudi() {
      this.$refs.cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent.salvaNuovoArticolo();
    },
    onUpdateRowNumberGiacenza(value) {
      this.rowsGiacenza = value;
    },
    getPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },
    onRowSelectedLottoMatricola(item) {
      this.rigaDocumento.lottiScadenze = item;
    },
    onAddLottoMatricola(lottoMatricole) {
      this.rigaDocumento.lottiScadenze = lottoMatricole;
    },

    onRowSelectedArticoliItems(item) {
      if (item[0]) {
        this.arraySelezionati.articolo = item;
        let articolo = item[0];
        this.setDatiArticoloScelto(articolo);
        this.setDatiUmRigaDocumento(articolo);
        this.setDatiIvaRigaDocumento(articolo);
        this.setIsGestione(articolo);
      } else {
        this.onResetRigaDocumento();
      }
    },
    setIsGestione(articolo) {

      if (articolo.gestioneLottiScadenze || articolo.gestioneMatricole) {
        this.gestione = true;
      } else {
        this.gestione = false;
      }
      console.log(this.gestione);

    },
    setDatiArticoloScelto(articolo) {
      let me = this;
      me.rigaDocumento.descrizione = articolo.nomeArticolo;
      me.rigaDocumento.codiceArticolo = articolo.codiceArticolo;
      me.rigaDocumento.idArticolo = articolo.id;
      if (!this.isModificaRigaDocumento) {
        me.rigaDocumento.prezzoUnitario = articolo.prezzoAcquistoStandard;
      }
    },
    setDatiIvaRigaDocumento(articolo) {
      let me = this;
      let codiceIva = articolo.codiceIva;
      let ivaObj = me.contabilitaIvaOptions.filter((e) => e.codiceIva == codiceIva);
      if (ivaObj.length > 0) {
        me.rigaDocumento.ivaDescrizione = ivaObj[0].descrizioneIva;
        me.rigaDocumento.ivaAliquota = ivaObj[0].aliquotaIva;
        me.rigaDocumento.ivaCodice = ivaObj[0].codiceIva;
      }
    },
    setDatiUmRigaDocumento(articolo) {
      let me = this;
      let umId = articolo.umId;
      let um = me.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.id == umId);
      if (um.length > 0) {
        let unitaMisura = um[0];
        me.rigaDocumento.umCodice = unitaMisura.codiceMoltiplicatore;
        me.rigaDocumento.umDescrizione = unitaMisura.descrizioneMultiplo;
        me.rigaDocumento.umMultiplo = unitaMisura.multiplo;
      }
    },
    onClickCloseRicercaArticolo(value) {
      this.rigaDocumento[value] = null;
    },
    onResetRigaDocumento() {
      this.rigaDocumento = {
        id: "-1",
        idArticolo: null,
        codiceArticolo: null,
        descrizione: null,
        umCodice: null,
        umDescrizione: null,
        umMultiplo: 0,
        quantita: 1,
        prezzoUnitario: 0,
        sconto: 0,
        ivaCodice: null,
        ivaDescrizione: null,
        ivaAliquota: 0,
        codiceTipoSpesa: null,
        descrizioneImballo: null,
        colli: 0,
        totaleRiga: 0,
        lottiScadenze: [],
        documentoRiferimentoDescrizione: null,
        documentoRiferimentoId: null,
        documentoRiferimentoRigaId: null,
        documentoRiferimentoRigaQuantita: null,
      };
    },
    onHideRigaDocumento() {
      this.onResetRigaDocumento();
      this.gestione = false;
    },
    validazioneLottiMatricole() {
      let esito = true;
      let msg = "";
      if (this.rigaDocumento.lottiScadenze.length == 0) {
        msg += "Lotti Matricole Vuote ! #";
        esito = false;
        return { esito: esito, msg: msg };
      }
      let numeriLottiMassimale = this.rigaDocumento.quantita;
      let numeroLottiAttuali = 0;
      for (const [i, lottoMatricola] of this.rigaDocumento.lottiScadenze.entries()) {
        if (lottoMatricola.lottoMatricola == null || lottoMatricola.lottoMatricola.trim() == "") {
          msg += `Indice: ${i + 1} - Codice Lotto/Matricola non valido ! #`;
          esito = false;
        }
        // if (lottoMatricola.dataOraProduzione == null || lottoMatricola.dataOraProduzione == 0) {
        //   msg += `Indice: ${i + 1} - Data Produzione non valida ! #`;
        //   esito = false;
        // }
        if (lottoMatricola.dataOraScadenza == null || lottoMatricola.dataOraScadenza == 0) {
          msg += `Indice: ${i + 1} - Data Scadenza non valida ! #`;
          esito = false;
        }
        numeroLottiAttuali += lottoMatricola.quantita;
      }
      if (numeroLottiAttuali > numeriLottiMassimale) {
        msg = `Il numero dei Lotti inseriti supera il limite della quantita impostata sulla riga ! #`;
        esito = false;
        return { esito: esito, msg: msg };
      }
      return { esito: esito, msg: msg };
    },
    validazione() {
      let esito = true;
      let msg = "";
      if (this.arraySelezionati.articolo == null) {
        msg += "Articolo non selezionato ! #";
        esito = false;
      }
      if (this.rigaDocumento.codiceArticolo == null || this.rigaDocumento.codiceArticolo.trim() == "") {
        msg += "Codice Articolo non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.descrizione == null || this.rigaDocumento.descrizione.trim() == "") {
        msg += "Descrizione Articolo non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.umCodice == null || this.rigaDocumento.umCodice.trim() == "") {
        msg += "Unita Misura non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.codiceTipoSpesa == null || this.rigaDocumento.codiceTipoSpesa.trim() == "") {
        msg += "Codice Spesa non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.ivaCodice == null || this.rigaDocumento.ivaCodice.trim() == "") {
        msg += "Codice Iva non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.quantita == null || this.rigaDocumento.quantita <= 0) {
        msg += "Quantita non valida ! #";
        esito = false;
      }
      if (this.rigaDocumento.prezzoUnitario == null || this.rigaDocumento.prezzoUnitario < 0) {
        msg += "Prezzo Unitario non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.sconto == null) {
        msg += "Sconto non valido ! #";
        esito = false;
      }
      return { esito: esito, msg: msg };
    },
    generaBtoast(validation) {
      toast.validation(validation)
    },
  },
};
</script>

<style scoped>
.sa-flex-box-main-right {
  width: 300px !important;
}


.sa-badge-data {
  padding-right: 2px !important;
}

.sa-badge-data-matricola {
  overflow: visible;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 50px;
}

.sa-badge-group-lotti {
  height: 320px;
  display: block;
  overflow: scroll;
  overflow-x: hidden;
}

.sa-badge-group-matricole {
  height: 400px;
  display: block;
  overflow: scroll;
}

.sa-badge {
  padding: 5px !important;
  transition: all 0.1s linear;
  cursor: pointer;
  max-width: initial;
}

.sa-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 255, 255, 0.651);
}

.sa-badge-ft-disable-class {
  background-color: var(--sa-data-text-color);
  cursor: not-allowed;
  border-left: 3px solid #a71d2a;
}

.sa-badge-ft-active-class {
  transform: translateY(-2px);
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 1px solid var(--bg-sidebar) !important;
  border-color: var(--bg-sidebar) !important;
  background-color: var(--bg-button-press-color);
}

.sa-badge-ft-active-class:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 1px solid var(--bg-sidebar) !important;
  border-color: var(--bg-sidebar) !important;
  background-color: var(--bg-button-press-color);
}

.sa-badge-ft-disable-class:hover {
  transform: translateY(0px);
}

.sa-box-matricole {
  background-color: white;
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  top: 0;
  right: 0;
  left: 0;
  padding: 5px;
}

::v-deep .sa-ft-circle-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 15px 25px;
  font-weight: bold;
  border: 2px solid var(--color-status);
  background-color: rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
}

/* Il primo numero: segue lo stato */
::v-deep .sa-ft-circle-value-current {
  color: var(--color-status);
}

/* Lo slash e il secondo numero: sempre blu */
::v-deep .sa-ft-circle-separator,
::v-deep .sa-ft-circle-total {
  color: var(--color-main);
  margin-left: 2px;
}

::v-deep .sa-ft-circle-separator {
  margin: 0 3px;
}

.sa-box-matricole-hidden {
  opacity: 0;
  visibility: hidden;
  transition: all 1s ease-in-out;
}

.sa-box-matricole-visible {
  visibility: visible;
  opacity: 1;
  transition: all 1s ease-in-out;
}

.sa-modal-static-scroll .modal-content {
  height: calc(100vh - 25rem) !important;
}

.row div {
  /* padding-bottom: var(--pd-form-element); */
  padding-bottom: 0px !important;
}
</style>
